<template>
  <v-card>
    <EditDialog ref="dialog" @reload="$emit('reload')" />

    <ORow class="pa-4">
      <span class="headline">Cadastro</span>
      <v-spacer />
      <v-btn icon @click="openDialog">
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
      <OMenuButton :menuOpts="[{ text: 'Desativar', onClick: confirmDelete }]" />
    </ORow>
    <v-divider />
    <v-card-text class="pa-0 children-pa-4">
      <div v-if="row.deletedAt != null" class="tag red">
        Desativado em {{ row.deletedAt | moment('DD/MMM/YYYY HH:mm') }}
      </div>
      <div class="cap-cont">
        <label>Nome</label>
        <p>{{ row.name }}</p>
      </div>
      <div class="cap-cont">
        <label>Valor Instalação</label>
        <p>{{ row.installValue | brMoney | ifBlank }}</p>
      </div>
      <div class="cap-cont">
        <label>Valor Remoção</label>
        <p>{{ row.removeValue | brMoney | ifBlank }}</p>
      </div>
      <div class="cap-cont">
        <label>Estoque associado</label>
        <p v-if="row.depot == null">&mdash;</p>
        <p v-else>{{ row.depot.name }}</p>
      </div>
      <div class="cap-cont">
        <label>Criado</label>
        <p>{{ row.createdAt | moment('DD/MMM/YYYY HH:mm') }}</p>
      </div>
      <div class="cap-cont">
        <label>Atualizado</label>
        <p>{{ row.createdAt | moment('DD/MMM/YYYY HH:mm') }}</p>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import EditDialog from './EditDialog.vue'
import { Technician, minMs3 } from '@/models'

export default {
  components: { EditDialog },
  props: {
    row: { required: true }
  },
  methods: {
    openDialog() {
      this.$refs.dialog.open(this.row.id)
    },
    async confirmDelete() {
      let message = `Tem certeza que deseja desativar o técnico ${this.row.name}?`
      let res = await this.$confirmDelete({
        message,
        okText: 'Sim, desativar'
      })

      if (res) {
        this.$loading(async () => {
          await minMs3(async () => {
            await Technician.delete(this.row.id)
          })

          this.$snack('Desativado com sucesso')
          this.$emit('reload')
        })
      }
    }
  }
}
</script>

<style></style>
